import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'


export default {
  namespaced: true,
  state: {

  },
  getters: {},
  mutations: {},
  actions: {
   getReportProductCategory() {
  

      return new Promise((resolve, reject) => {
        const body = {
          "name": "",
          "createdOnStart": null,
          "createdOnEnd": null,
          "shopId": null
        }

        axios
          .post(`${baseURL}/api/Dashboard/ReportProductCategory`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
          
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
   },
   getReportProductCategorySell() {
  

      return new Promise((resolve, reject) => {
        const body = {
          "name": "",
          "shopId": null,
          "dateType": 0
        }

        axios
          .post(`${baseURL}/api/Dashboard/ReportProductCategorySell`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
      
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
   },
   getReportSummaryBestSellProduct() {


      return new Promise((resolve, reject) => {
        const body = {
          "name": "",
          "createdOnStart": null,
          "createdOnEnd": null,
          "shopId": null
        }

        axios
          .post(`${baseURL}/api/Dashboard/ReportSummaryBestSellProduct`, body, {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
        
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
   }
  },
}
